export class AuditorBenchAuditDetailScopeDetailDTO {
  auditProgramId: string;
  scopeId: string;
  scopeDescription: string;
  importantTips: string;
  orderId: string;
  departmentId: string;
  sectionId: string;
  isWorkflowRequired: string;
  isPostCommentPosted: string;
  auditNcFinalizedBy: string;
  isDraftReportReleased: string;
  isMcReleased: string;
  isFinalReportReleased: string;
  isPostCommentExists: string;
  statusId: string;
  cdScopeItemStatus: string;
  postCommentCount: string;
  attachmentCount: string;
  pendingItemCount: string;
  auditorNcWfReqId: string;
  auditorNcWfReqStatusId: string;
  isAttachmentExists: string;
  subObservationParentId: string;
  isPersistenceNc: string;
  cdPdcaStatus: string;
  cdReturnStatus: string;
  wfDeptId: string;
  ratingMstId: string;
  sectionOrder: string;
  executiveSummary: string;
  auditorObservation: string;
  recommendation: string;
  impactComments: string;
  joinderRemarks: string;
  rcoComments: string;
  cdReasonId: string;
  includeInReport: string;
  managementResponse: string;
  auditeeWfReqId: string;
  auditeeWfReqStatusId: string;
  auditeePncWfReqId: string;
  auditeePncWfReqStatusId: string;
  auditeeTargetDate: string;
  auditeeRevisedTargetDate: string;
  persistenceManagementResponse: string;
  auditorPersistenceComment: string;
  auditorReturnRemarks: string;
  postedCmnt: string;
  isPostComment: string;
  remarks: string;
  entBy: string;
  entStamp: string;
  updBy: string;
  updStamp: string;
  isObservationApplicable: string = '1';
  isIncludeInReport: string = '1';
  actionType: string;
  scopePrivilege: string;
  auditorComment: string;
  pdcaStatus: string;
  isPnc: string;
  ncStage: string;
  departmentName: string;
  sectionName: string;
  cssClass: string = 'pending';
  userRoleId: string;
  eventId: string;
  auditProgramName: string;
  auditPeriod: string;
  returnNcPncFlag: string;
  isPncRecall: string;
  modifiedBy: string;
  modifiedOn: string;
  revisedTargetDateMailIntimation: boolean = false;
  riskImpact: string;
  gvRemarks: any;
  isGvEnabled: any;
  gvCreatedBy: any;
  userId: any;
  pId: any;

  checkForFirstRemark: any;
  isclosed: any;

  observationNumber: string;
  completionDate: string;
  observationOwner: string;
  effectiveCompletionDate: string;
  ratingID: any;
  revisedplanCompletionDate: string;
  applicableScore: number;
  observationTitle: string;
  auditorManagementActionPlan: string
}
